
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Service Detail Pages
const SchengenCPage = lazy(() => import('../pages/services/schengen-c/page'));
const SchengenDPage = lazy(() => import('../pages/services/schengen-d/page'));
const AmerikaVizesiPage = lazy(() => import('../pages/services/amerika-vizesi/page'));
const IngiltereVizesiPage = lazy(() => import('../pages/services/ingiltere-vizesi/page'));
const OturumKartiPage = lazy(() => import('../pages/services/oturum-karti/page'));
const AileBirlesmesiPage = lazy(() => import('../pages/services/aile-birlesmesi/page'));
const EVizePage = lazy(() => import('../pages/services/e-vize/page'));

// Blog Pages
const BlogPage = lazy(() => import('../pages/blog/page'));
const SchengenVizeBasvuruRehberiPage = lazy(() => import('../pages/blog/schengen-vize-basvuru-rehberi/page'));
const AmerikaVizeMulakatHazirligiPage = lazy(() => import('../pages/blog/amerika-vize-mulakat-hazirligi/page'));
const VizeBasvurusuEvrakListesiPage = lazy(() => import('../pages/blog/vize-basvurusu-evrak-listesi/page'));
const VizeReddiNedenleriPage = lazy(() => import('../pages/blog/vize-reddi-nedenleri/page'));
const OturumKartiBasvuruSureciPage = lazy(() => import('../pages/blog/oturum-karti-basvuru-sureci/page'));
const SeyahatSigortasiOnemleriPage = lazy(() => import('../pages/blog/seyahat-sigortasi-onemleri/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />,
  },
  {
    path: '/hizmetler/schengen-c-tipi-vize',
    element: <SchengenCPage />,
  },
  {
    path: '/hizmetler/schengen-d-tipi-vize',
    element: <SchengenDPage />,
  },
  {
    path: '/hizmetler/amerika-vizesi',
    element: <AmerikaVizesiPage />,
  },
  {
    path: '/hizmetler/ingiltere-vizesi',
    element: <IngiltereVizesiPage />,
  },
  {
    path: '/hizmetler/oturum-karti',
    element: <OturumKartiPage />,
  },
  {
    path: '/hizmetler/aile-birlesmesi',
    element: <AileBirlesmesiPage />,
  },
  {
    path: '/hizmetler/e-vize',
    element: <EVizePage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/kvkk',
    element: <KVKKPage />,
  },
  {
    path: '/cerez-politikasi',
    element: <CookiePolicyPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/schengen-vize-basvuru-rehberi',
    element: <SchengenVizeBasvuruRehberiPage />,
  },
  {
    path: '/blog/amerika-vize-mulakat-hazirligi',
    element: <AmerikaVizeMulakatHazirligiPage />,
  },
  {
    path: '/blog/vize-basvurusu-evrak-listesi',
    element: <VizeBasvurusuEvrakListesiPage />,
  },
  {
    path: '/blog/vize-reddi-nedenleri',
    element: <VizeReddiNedenleriPage />,
  },
  {
    path: '/blog/oturum-karti-basvuru-sureci',
    element: <OturumKartiBasvuruSureciPage />,
  },
  {
    path: '/blog/seyahat-sigortasi-onemleri',
    element: <SeyahatSigortasiOnemleriPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
